/**
 * Supported locales.
 *
 * French and Arabic are the priority languages for MVP (PDF §27); English is
 * secondary and included only because the master plan names it as the
 * eventual third option, not because any English copy exists yet.
 */
export const SUPPORTED_LOCALES = ['fr', 'ar', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'fr';

export function isSupportedLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
